import View from './Eula';
import enhancer from './Eula.enhancer';

const Eula = enhancer(View);

export default Eula;
